import i18n from "utils/i18n/i18n";

export default {
  assessmentQuestion: i18n.t("student.assessmentQuestion"),
  confirmButton: i18n.t("student.startAssessmentConfirm"),
  rejectButton: i18n.t("student.notNow"),
};
